import { render } from "./Rotate.vue?vue&type=template&id=5b05f12e"
import script from "./Rotate.vue?vue&type=script&lang=js"
export * from "./Rotate.vue?vue&type=script&lang=js"

import "./Rotate.vue?vue&type=style&index=0&id=5b05f12e&lang=scss"

import exportComponent from "/Users/gray/Desktop/Work_temp/經貿網/web/project/rotate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__